export const PAGE_TITLE = 'Helping you navigate the cancer experience.';
export const PAGE_DESCRIPTION =
    'Manta Cares has built the ultimate self-advocacy toolkit for cancer. It includes, disease-specific maps, care management tools, and expert specialists to guide you from diagnosis through to the new normal.';
export const CREATE_AN_ACCOUNT = 'Create an account';
export const MANTA_CARE_EQUIPS_YOU = 'Manta Cares Equips You';
export const CANCER_MAP = 'Cancer Map';
export const CANCER_MAP_DESCRIPTION =
    'Our subway-like cancer maps show you all the paths you might face during your experience, give you questions to ask your doctor, and provide you with resources to help you navigate this new (and scary!) time more easily.';
export const MANAGEMENT_TOOLS = 'Management Tools';
export const MANAGEMENT_TOOLS_DESCRIPTION =
    'We give you the tools like an appointment notebook, symptom tracker & more to help you manage your care and stay organized.';
export const GUIDES = 'Guides';
export const GUIDES_DESCRIPTION =
    'A community of experts (yes, actual people!) who can help you with different parts of your cancer experience from nutrition to fitness to peer navigation support.';
export const CANCER_ORGANIZATIONS = 'We are trusted by leading health organizations and patient communities.';
export const CANCER_COMMUNITIES = 'Built for the Cancer Community, by the Cancer Community.';
export const MANTA_CARES_SINCE = '© 2024, Manta Cares';
